import React from 'react';

import { FORMS } from '../../schemas/stepMap';
import InvestmentCriteriaOverview from '../../components/property-summaries/InvestmentCriteriaOverview';

export default function BRRRRInvestmentCriteria({
  propertyData = {},
  scenarioData = {},
}) {
  const combined = { ...propertyData, ...scenarioData };
  const { refinancingWorksheetSubmitted } = combined || {};

  return (
    <InvestmentCriteriaOverview
      schema={FORMS.BRRRRAnalysis.investmentMetrics}
      data={combined}
      type="overview"
      disabled={!refinancingWorksheetSubmitted}
    />
  );
}
